import { validateLogin } from "./validateLogin.jsx";

export const callLogin = async ({ user, request }) => {
  const { url, method } = request;
  const { username, password } = user;

  const validation = validateLogin({ username, password });

  if (!validation.success) {
    return {
      success: false,
      message: validation.errors,
    };
  }

  try {
    const response = await fetch(url, {
      method: method,
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(user),
    });

    if (response.ok) {
      const data = await response.json();

      return {
        success: true,
        message: data.message,
        token: data.token,
        user: data.user,
      };
    } else {
      return {
        success: false,
        message: "Credenciales incorrectas",
      };
    }
  } catch (err) {
    return {
      success: false,
      message: err.message,
    };
  }
};
